// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import OETIFSelectorTemplate from '@front/templates/OETIFSelectorTemplate.html';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { OrderExecutorUtils } from '@shared/commons/Trading/OrderExecutorUtils';
import { Resources } from '@shared/localizations/Resources';
import { createContextMenuItemsFromEnum } from '@shared/utils/ContextMenuUtils';
import { TIF } from '@shared/utils/Trading/OrderTif';
import { OrderTif, getOrderTifKey, sortTifs } from '@shared/utils/Trading/OrderTifEnum';
import { ContainerControl } from '../../elements/ContainerControl';
import { ControlsTypes } from '../../UtilsClasses/FactoryConstants';
// TODO. Move logic to TerceraTIFComboBox?
// TODO. Fix last selected + default TIF.
export class OETIFSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.OETIFSelector;
    }
    oninit() {
        super.oninit();
        this.observe('orderType instrument defaultTif', this.repopulate);
        this.observe('selectedItem gtdDate', this.updateTIF);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    localize() {
        void this.set('label', Resources.getResource('panel.newOrderEntry.tifPanel'));
    }
    updateTIF() {
        OETIFSelector.GetAdvancedUpdateTIF(this);
    }
    repopulate() {
        const orderType = this.get('orderType');
        const orderTypeId = orderType ? orderType.id() : null;
        OETIFSelector.PopuplateTifComboboxAsync([orderTypeId], this);
    }
    static PopuplateTifComboboxAsync(orderTypesArray, panel) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const instrument = (_a = panel.get('instrumentItem')) !== null && _a !== void 0 ? _a : panel.get('instrument');
            const orderTypeId = orderTypesArray[0];
            void panel.set('orderTypeId', orderTypeId);
            let tifs = [];
            if (orderTypeId && instrument) {
                for (let i = 0; i < orderTypesArray.length; i++) {
                    const orderTypeAllowedTifs = OrderExecutorUtils.getAllowedTIFArray(orderTypesArray[i], instrument);
                    for (let j = 0; j < orderTypeAllowedTifs.length; j++) {
                        const orderTypeAllowedTif = orderTypeAllowedTifs[j];
                        if (!tifs.Contains(orderTypeAllowedTif)) {
                            tifs.push(orderTypeAllowedTif);
                        }
                    }
                }
            }
            tifs = sortTifs(tifs);
            const items = createContextMenuItemsFromEnum(OrderTif, getOrderTifKey, (tif) => {
                return tifs.Contains(tif);
            });
            yield panel.set('items', items);
            let defaultTif = SessionSettings.getDefaultTifForOrderType(orderTypeId);
            if (!isValidArray(items)) {
                return Promise.resolve();
            }
            const orderTif = panel.get('defaultTif');
            if (!isNullOrUndefined(orderTif)) {
                defaultTif = orderTif.type;
            }
            let selectedOrderTif = (_b = panel.get('selectedItem')) === null || _b === void 0 ? void 0 : _b.value;
            if (!isNullOrUndefined(items.find((item) => item.value === defaultTif))) {
                selectedOrderTif = defaultTif;
            }
            for (let i = 0, len = items.length; i < len; i++) {
                const item = items[i];
                if (item.value === selectedOrderTif) {
                    yield panel.set('selectedItem', item);
                    const expTime = selectedOrderTif === OrderTif.GTD
                        ? (orderTif ? orderTif.expirationTime : null) ||
                            TIF.getDefaultExpireTimeForOrderType(orderTypeId, instrument)
                        : new Date();
                    if (!isNullOrUndefined(expTime)) {
                        yield panel.set('gtdDate', expTime);
                    }
                    return Promise.resolve();
                }
            }
            return Promise.resolve();
        });
    }
    static GetAdvancedUpdateTIF(panel) {
        let result = null;
        const selectedItem = panel.get('selectedItem');
        if (!isNullOrUndefined(selectedItem)) {
            const tif = selectedItem.value;
            const isGTD = tif === OrderTif.GTD;
            result = new TIF(tif, isGTD ? panel.get('gtdDate') : null);
        }
        panel.set('tif', result);
    }
}
ContainerControl.extendWith(OETIFSelector, {
    template: OETIFSelectorTemplate,
    data: function () {
        return {
            label: '',
            orderType: null,
            instrument: null,
            items: null,
            orderTypeId: null,
            gtdDate: null,
            selectedItem: null,
            tif: null,
            // TODO. Remove. Ugly.
            defaultTif: null,
            showLabel: true,
            width: 198
        };
    }
});
